module.exports = __webpack_public_path__ + "media/images/general/brands/jcb-5fe955dbc72f6f529cf7478e7e96654a.png";